module.exports = __webpack_public_path__ + "static/media/dish_card5.68e69c13.png";